import React, { Component } from "react";
import styled from "styled-components";
import space from './space.jpg';

const HeroWrapper = styled.header`
  position: relative;
  background-image: url(${space});
  background-color: #333333;
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  margin-bottom: 2.0em;
  padding-top: 2.2em;
  padding-bottom: 2.2em;
  
  @media (min-width: 420px) {
    padding-top: 4.95em;
    padding-bottom: 4.95em;
  }
  @media (min-width: 600px) {
    padding-top: 7.7em;
    padding-bottom: 7.7em;
  }
  @media (min-width: 900px) {
    padding-top: 10.45em;
    padding-bottom: 10.45em;
  }
  @media (min-width: 1100px) {
    padding-top: 13.2em;
    padding-bottom: 13.2em;
  }
  @media (min-width: 1300px) {
    padding-top: 18.7em;
    padding-bottom: 18.7em;
  }

  h1 {
    text-align: center;
    font-weight: 300;
    letter-spacing: 1px;
    color: #fff;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 2.55em;
    padding-top: 0.275em;
    font-size: 2em;
    line-height: 1.2375em;
  }
  @media (min-width: 600px) {
    h1 {
      font-size: 2.625em;
      line-height: 1.152381em;
    }
  }
`;

class Hero extends Component {
  render() {
    return (
      <HeroWrapper>
        <h1>Planet-Scale Blockchain Services</h1>
      </HeroWrapper>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/App/Home/Hero/index.js